export default __webpack_public_path__ + "static/media/by_softavera.1252f13e.svg";